import { render, staticRenderFns } from "./top-adv.vue?vue&type=template&id=a5859c66"
import script from "./top-adv.vue?vue&type=script&lang=js"
export * from "./top-adv.vue?vue&type=script&lang=js"
import style0 from "./top-adv.vue?vue&type=style&index=0&id=a5859c66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports